import { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Signup } from "../signup";
import LoginForm from "./LoginForm";
import { getHomeDashboardPath } from "../../../utils/dashboardRoutes";
import { getStoredUserData, hasSessionToken } from "../../../utils/authSession";
import { Icon } from "../../shared/icons/generate-icon";
import { primaryColor } from "../../shared/styles/color";
import { fontFamily } from "../../shared/styles/theme";

export default function LiberLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const isAdminLogin = location.pathname.startsWith("/admin/login");

  useEffect(() => {
    const userData = getStoredUserData();
    // Only skip login when we have both a user profile AND a JWT.
    // A stale user object without a valid token must not block re-login.
    if (userData?.user && hasSessionToken(userData)) {
      navigate(getHomeDashboardPath(userData.user), { replace: true });
    }
  }, [navigate]);

  if (isAdminLogin) {
    return <AdminLoginPage />;
  }

  return <Signup />;
}

function AdminLoginPage() {
  return (
    <AdminShell>
      <AdminInner>
        <BrandLink to="/home">
          <Icon src="/Logo.png" style={{ height: "36px", width: "36px" }} />
          <BrandName>Liber</BrandName>
        </BrandLink>
        <LoginForm variant="admin" />
      </AdminInner>
    </AdminShell>
  );
}

const AdminShell = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  box-sizing: border-box;
  background: #f5f7f9;
`;

const AdminInner = styled.div`
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

const BrandLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
`;

const BrandName = styled.span`
  font-family: ${fontFamily.font};
  font-weight: 700;
  font-size: 22px;
  color: ${primaryColor};
`;
